import app from "../_app";

if(app.viewport.isEqualOrGreaterThan('lg')) {
    const productImagesPopup = document.querySelector('.js-product-images-popup');

    if(productImagesPopup) {
        const triggers = [...document.querySelectorAll('.js-product-images-popup-trigger')];
        const close = document.querySelector('.js-product-images-popup-close');

        triggers.map(trigger => trigger.addEventListener('click', () => {
            app.lockBody(false);

            const selectedImage = productImagesPopup.querySelector(`[data-image="${trigger.dataset.image}"]`);
            productImagesPopup.setAttribute('data-open', '');
            productImagesPopup.scrollTo({top: selectedImage.offsetTop});
        }));

        close.addEventListener('click', () => {
            productImagesPopup.removeAttribute('data-open');
            app.unlockBody();
        });
    }
}
